<rask-header [uppercase]="true">
    {{texts.kundorder}}
</rask-header>
<rask-container-block>
    <ng-container header>{{texts.omkorningAvKopplaKundorderHS}}</ng-container>
    <div class="row">
        <div class="col-12">
            <rask-input col="3" label="Leveransnummer" [(ngModel)]="kundorderRequest.leveransnummer">
            </rask-input>
            <rask-selector [label]="texts.leveransmatningar"
                [values]="korList"
                [(ngModel)]="kundorderRequest.kor"
                [viewFormatter]="viewFormatter"
                [formatter]="outputFormatter">
            </rask-selector>
        </div>
    </div>
    <rask-datepicker-interval
        [labelStartDate]="texts.matdatumFrom"
        [labelEndDate]="texts.matdatumTom"
        (startDate)="setMatningFrom($event)"
        (endDate)="setMatningTom($event)">
    </rask-datepicker-interval>
    <rask-input [label]="texts.huvudkodInternnummer"
        [(ngModel)]="kundorderRequest.kundHuvudkodInternnummer">
    </rask-input>
    <rask-input [label]="texts.mottagningsplatsnummer"
        [(ngModel)]="kundorderRequest.mottagningsplatsNummer">
    </rask-input>
    <rask-response-panel
        [show]="!!antalLagertransaktioner"
        label="Resultat ({{antalLagertransaktioner}})"
        [message]="antalLagertransaktioner"></rask-response-panel>
    <ng-container footer>
        <rask-button color="secondary" (click)="kundorderOmkorning()">{{'DEFAULT_BUTTON_LABEL_OMKORNING' | translate}}
        </rask-button>
    </ng-container>

</rask-container-block>
